import { useEffect, useState } from "react";
import { apiGet } from "../lib/api";
import { Card, Th, Td } from "../components/ui";

type Obj = { key: string; size: number; uploaded: string };

function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export default function BackupsScreen() {
  const [objects, setObjects] = useState<Obj[] | null>(null);

  useEffect(() => {
    apiGet<{ objects: Obj[] }>("/api/admin/backups").then((r) => setObjects(r.objects));
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <h1 className="text-2xl text-ink">Backups</h1>
        <span className="text-sm text-neutral-400">nightly Forecasts snapshots · bucket core-backups</span>
      </div>
      <Card>
        {objects === null ? (
          <p className="text-sm text-neutral-400">Loading…</p>
        ) : objects.length === 0 ? (
          <p className="text-sm text-neutral-400">
            No backups yet. The nightly backup cron writes here once it has run — check back tomorrow morning.
          </p>
        ) : (
          <div className="overflow-x-auto">
          <table className="w-full min-w-[420px]">
            <thead>
              <tr>
                <Th>key</Th>
                <Th>uploaded</Th>
                <Th right>size</Th>
              </tr>
            </thead>
            <tbody>
              {objects.map((o) => (
                <tr key={o.key}>
                  <Td>{o.key}</Td>
                  <Td>{new Date(o.uploaded).toLocaleString("en-GB")}</Td>
                  <Td right>{formatBytes(o.size)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </Card>
    </div>
  );
}
